module.exports = __webpack_public_path__ + "img/client_logo_2.301d3fad.svg";